// extracted by mini-css-extract-plugin
export default {"header":"ForgotPassword_header__fIhJP","textPrimaryDark":"ForgotPassword_textPrimaryDark__5OJAZ"};